import { AsyncResp, requestPapi } from '@paradigm/api/src/fetch-api';
import { getQueryString } from '@paradigm/api/src/internal/utils';
import { Maybe } from '@paradigm/utils/types';
import {
  LiquidityListReq,
  RawLiquidityFillResp,
  RawLiquidityResponseResp,
} from '#/leaderboard/entities/liquidity';
import { getUtcDate } from '@paradigm/utils/src/date';

export async function listLiquidityFills(
  req: LiquidityListReq,
): AsyncResp<RawLiquidityFillResp> {
  const query = getLiquidityQuery(req);

  const resp = await requestPapi<RawLiquidityFillResp>({
    url: `/v1/leaderboard/liquidity/fills${query}`,
    method: 'GET',
    signal: req.signal,
  });

  return resp;
}

export async function listLiquidityResponses(
  req: LiquidityListReq,
): AsyncResp<RawLiquidityResponseResp> {
  const query = getLiquidityQuery(req);

  const resp = await requestPapi<RawLiquidityResponseResp>({
    url: `/v1/leaderboard/liquidity/responses${query}`,
    method: 'GET',
    signal: req.signal,
  });

  return resp;
}

function getLiquidityQuery(req: LiquidityListReq) {
  return getQueryString([
    ['currencies', getStringList(req.currencies)],
    ['instrument_kinds', getStringList(req.instrumentKinds)],
    ['protocols', getStringList(req.protocols)],
    ['venues', getStringList(req.venues)],
    ['strategies', getStringList(req.strategies)],
    ['start', getUtcDate(req.start)?.getTime()],
    ['end', getUtcDate(req.end)?.getTime()],
  ]);
}

function getStringList<T extends string>(list?: Maybe<readonly T[]>) {
  return list != null && list.length > 0 ? list.join(',') : null;
}
